var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 46,
    viewBox: "0 0 40 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0667 5.33333L24.4267 2.13333C24.1867 0.906667 23.0933 0 21.8133 0H2.66667C1.2 0 0 1.2 0 2.66667V42.6667C0 44.1333 1.2 45.3333 2.66667 45.3333C4.13333 45.3333 5.33333 44.1333 5.33333 42.6667V26.6667H20.2667L20.9067 29.8667C21.1467 31.12 22.24 32 23.52 32H37.3333C38.8 32 40 30.8 40 29.3333V8C40 6.53333 38.8 5.33333 37.3333 5.33333H25.0667Z",
    fill: "#CCCCD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.b1bcf350.svg";
export { ForwardRef as ReactComponent };